import React from 'react';
var SnippylyRecorderNotes = function (props) {
    var shadowDom = props.shadowDom, children = props.children, videoEditor = props.videoEditor;
    return (React.createElement("velt-recorder-notes", { "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "video-editor": [true, false].includes(videoEditor) ? (videoEditor ? 'true' : 'false') : undefined }, children));
};
export default SnippylyRecorderNotes;
